var map = {
	"./acer_monitor_27.jpg": 6016,
	"./adapter_plug.jpg": 3959,
	"./apple_ipad.jpg": 2570,
	"./apple_keyboard.jpg": 4731,
	"./apple_magsafe_duo_charger.jpg": 9083,
	"./apple_mouse.jpg": 7134,
	"./bose_portable_smart_speaker.jpg": 7520,
	"./bose_quientcomfort_35_headphones.jpg": 7852,
	"./canon_camera.jpg": 5077,
	"./card_set.jpg": 438,
	"./dji_drone_mini_3_pro.jpg": 2087,
	"./dji_selfie_stick.jpg": 7207,
	"./dyson_airwrap.jpeg": 868,
	"./dyson_hairdryer.jpg": 717,
	"./dyson_purifier_cool.jpg": 323,
	"./gopro_hero_11_black.jpg": 6888,
	"./hdmi_cable.jpg": 7258,
	"./hypervolt.jpg": 3339,
	"./lightning_charger.jpg": 9054,
	"./mamaroo_baby_swing.jpg": 5942,
	"./marshall_hifi.jpeg": 4055,
	"./meta_quest_2.jpg": 8037,
	"./microsoft_arc_mouse.jpg": 5632,
	"./microsoft_keyboard.jpg": 8533,
	"./monopoly.jpg": 9415,
	"./monopoly_deal.jpg": 5450,
	"./nintendo_switch.jpg": 8046,
	"./playstation5.jpg": 2377,
	"./poker_set.jpg": 3005,
	"./portable_charger.jpg": 4919,
	"./portable_fan.jpg": 8944,
	"./portable_humidifier.jpg": 5891,
	"./projector.jpg": 81,
	"./samsung_tablet.jpg": 2209,
	"./sonos_five.jpg": 5969,
	"./steanny_baby_stroller.jpg": 3281,
	"./theraface_pro.jpg": 9780,
	"./theragun_elite.jpg": 4473,
	"./usbc_charger_laptop.jpg": 6774,
	"./usbc_charger_phone.jpg": 7095,
	"./xbox_series_s.jpg": 2806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5088;